import { api } from '@/api';
import { queryOptions } from '@tanstack/react-query';
import { getQueryKeysFactory } from './queryKeysFactory';

export const getUserMembershipsQuery = () => {
  const { userKeys } = getQueryKeysFactory();

  return queryOptions({
    queryKey: userKeys.membershipList,
    initialData: undefined, // Needed
    queryFn: async () => {
      const response = await api.GetUserMemberships();

      return response.data.memberships;
    },
  });
};
